import moment from 'moment'

export default function (value, na = '') {
  // 2019-01-30 => 01/30/2019 (military => US)
  return value && value !== '' ? moment(value).format('MM/DD/YYYY') : na
}
